import { render, staticRenderFns } from "./ClassicTimeDimensionRow.vue?vue&type=template&id=0ad338d7&"
import script from "./ClassicTimeDimensionRow.vue?vue&type=script&lang=js&"
export * from "./ClassicTimeDimensionRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports